export type ComparablesKey = keyof Comparable;

export interface Comparable {
  street: string;
  lastSoldDate: string;
  lastSoldPrice: number;
  bathrooms: number;
  bedrooms: number;
  city: string;
  state: string;
  zipcode: string;
  finishedSqFt: string;
  yearBuilt: string;
  lotSize: string;
  distanceFromSource: number;
  geoLocation?: string;
  propertyType?: string;
  salesStatus?: string;
}

export interface DatafinitiStatus {
  type: string;
  isUnderContract?: boolean;
  date?: string;
  firstDateSeen: string;
  lastDateSeen: string;
  sourceURLs: string[];
  dateSeen: string[];
}
